import '../assets/main-navigation.js';
import '../assets/hero-slider.js';
import '../assets/search.js';
import '../assets/product-quantity.js';
import '../assets/footer-copyright.js';



/* Product Detail Page: Variant Functionality: Start */

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".weight-and-pricing__weights-button");
    const hiddenInput = document.querySelector("#selected-variant-id");
    const priceBox = document.querySelector(".weight-and-pricing__price");

    if (buttons.length > 0 && hiddenInput && priceBox) {
      buttons.forEach(btn => {
        btn.addEventListener("click", function () {
          // Remove active class from all buttons
          buttons.forEach(b => b.classList.remove("active"));
          this.classList.add("active");

          // Update hidden variant ID
          hiddenInput.value = this.getAttribute("data-variant-id");

          // Update price
          priceBox.textContent = this.getAttribute("data-price");
        });
      });
    }
  });

/* Product Detail Page: Variant Functionality: End */
/*Product Images*/
document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb){

    thumb.addEventListener('click',function(){

        document.getElementById('ProductMainImage').src=this.dataset.large;

        document.querySelectorAll('.product-gallery__thumb').forEach(function(t){
            t.classList.remove('active');
        });

        this.classList.add('active');

    });

});
/* Coupon Code Copy Start */
  document.addEventListener('DOMContentLoaded', function () {
    const copyBtn = document.querySelector('.product-detail-page__copy-coupon-code');
    const couponEl = document.querySelector('.product-detail-page__discount-coupon-code');
    const toast = document.getElementById('coupon-toast');

    if (copyBtn && couponEl && toast) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const code = couponEl.textContent.trim();

        // Copy to clipboard
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(showToast);
        } else {
          // Fallback for older browsers
          const textarea = document.createElement('textarea');
          textarea.value = code;
          document.body.appendChild(textarea);
          textarea.select();
          try {
            document.execCommand('copy');
            showToast();
          } catch (err) {
            console.error('Copy failed', err);
          }
          document.body.removeChild(textarea);
        }
      });

      function showToast() {
        toast.classList.add('show');
        setTimeout(() => {
          toast.classList.remove('show');
        }, 2000); // Toast stays for 2 seconds
      }
    }
  });
/* Coupon Code Copy End */
